/* Dünne Schicht über fetch: JSON rein, JSON raus, Fehler als deutsche Meldung */
export class ApiError extends Error {
  constructor(public status: number, message: string) { super(message); }
}

/* Wird gerufen, wenn der Server eine bestehende Anmeldung nicht mehr kennt (z. B. Sitzung abgelaufen) */
let onUnauthorized: (() => void) | null = null;
export function setUnauthorizedHandler(fn: () => void) { onUnauthorized = fn; }

async function call<T>(method: string, url: string, body?: unknown, signal?: AbortSignal): Promise<T> {   /* signal: Abbrechen durch den Nutzer (Runde 276) — fetch wirft dann AbortError */
  const res = await fetch(url, {
    method,
    headers: body !== undefined ? { 'Content-Type': 'application/json' } : undefined,
    body: body !== undefined ? JSON.stringify(body) : undefined,
    credentials: 'same-origin',
    signal
  });
  const text = await res.text();
  let data: any = null;
  try { data = text ? JSON.parse(text) : null; } catch { data = null; }
  if (res.status === 401 && onUnauthorized && !url.startsWith('/api/login') && !url.startsWith('/api/me') && !url.startsWith('/api/setup')) onUnauthorized();
  if (!res.ok) throw new ApiError(res.status, (data && data.error) || `Fehler ${res.status}`);
  return data as T;
}

export const api = {
  get: <T>(url: string) => call<T>('GET', url),
  post: <T>(url: string, body?: unknown, signal?: AbortSignal) => call<T>('POST', url, body ?? {}, signal),
  patch: <T>(url: string, body: unknown) => call<T>('PATCH', url, body),
  put: <T>(url: string, body: unknown) => call<T>('PUT', url, body),
  del: <T>(url: string) => call<T>('DELETE', url)
};
